import React from 'react';

import FallbackSpinner from '../../components/loader/FallbackSpinner';
import createRouteLoadable from './createRouteLoadable';

export const CUSTOMER_PRODUCTS_PAGE_CHUNK_NAME = 'sortingLists';

export const CustomerProductsPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "sortingLists" */ '../../pages/CustomerProductsPage'
    ),
  {
    fallback: <FallbackSpinner />,
  }
);
